import React from 'react'

interface KpiTileProps {
  icon: React.ReactNode
  label: string
  value: string
  unit?: string
  delta?: string | null
  variant?: 'default' | 'dark' | 'warn'
}

// KPI tile from the Georgia manager dashboard mockup: default (white), dark (brand), warn (amber border)
const KpiTile: React.FC<KpiTileProps> = ({ icon, label, value, unit, delta, variant = 'default' }) => {
  const isDark = variant === 'dark'
  const isWarn = variant === 'warn'

  return (
    <div
      className="rounded-[10px] px-3.5 py-3"
      style={{
        background: isDark ? 'var(--m2-brand)' : 'var(--m2-card)',
        border: `1px solid ${isWarn ? '#FFE0B8' : 'var(--m2-line)'}`,
      }}
    >
      <div className="flex items-center gap-1.5 text-[10.5px] mb-1.5" style={{ color: isDark ? 'var(--m2-lime)' : 'var(--m2-muted)' }}>
        <span style={isWarn ? { color: '#C97A18' } : undefined}>{icon}</span>
        {label}
      </div>
      <div className="flex items-baseline gap-1">
        <div className="text-[22px] font-bold leading-none" style={{ color: isDark ? 'var(--m2-lime)' : 'var(--m2-ink)' }}>
          {value}
        </div>
        {unit && (
          <div className="text-[11px]" style={{ color: isDark ? 'rgba(255,255,255,0.7)' : 'var(--m2-muted)' }}>
            {unit}
          </div>
        )}
      </div>
      {delta && (
        <div className="text-[10px] font-medium mt-1" style={{ color: isDark ? 'rgba(197,242,106,0.85)' : isWarn ? '#C97A18' : '#3D8B5C' }}>
          {delta}
        </div>
      )}
    </div>
  )
}

export default KpiTile
